// api/month_end_report : 月末報告書を発行するAPI

import Api from './api_base'

export default {
  // POST /monthReport 教室情報を登録する param{ id,sheetsName,date[]}
  post: (data) => {
    return Api.post('/monthReport', data)
  }
}



// WEBPACK FOOTER //
// ./src/api/month_end_report.js